export default __webpack_public_path__ + "static/The Home_Image 5_carousel 3@2x-8158eba669844f23ff2aa71fc353aa8c.jpg";